$(document).ready(function () {

  // ===== HELPERS =====

  function parseMoney(val) {
    if (!val && val !== 0) return 0;
    var s = val.toString().replace(/,/g, "").trim();
    if (s === "" || s === "-") return 0;
    if (!/^-?\d+$/.test(s)) return 0;
    return parseInt(s, 10) || 0;
  }

  function formatMoney(val) {
    const num = parseInt(val, 10) || 0;
    return num.toLocaleString("ja-JP");
  }

  // Allow only integers (and a leading minus sign); remove letters and other characters immediately upon input.
  function sanitizeExpenseNumericInput(raw) {
    var s = String(raw || "").replace(/,/g, "");
    var sign = "";
    if (s.charAt(0) === "-") {
      sign = "-";
      s = s.slice(1);
    }
    s = s.replace(/\D/g, "");
    if (s.length === 0) {
      return sign;
    }
    return sign + s;
  }

  // ===== ROW / COLUMN TOTALS =====

  function recalcRowTotal($row) {
    var total = 0;
    $row.find(".js-expense-amount").each(function () {
      total += parseMoney($(this).val());
    });
    $row.find(".js-row-total input").val(formatMoney(total));
  }

  function recalcColTotals($table) {
    $table.find(".js-col-total").each(function () {
      var yearMonth = $(this).data("year-month");
      var colTotal = 0;
      $table.find(".js-expense-amount[data-year-month='" + yearMonth + "']").each(function () {
        colTotal += parseMoney($(this).val());
      });
      $(this).find("input").val(formatMoney(colTotal));
    });
  }

  function recalcGrandTotal($table) {
    var grand = 0;
    $table.find(".js-col-total").each(function () {
      grand += parseMoney($(this).find("input").val());
    });
    $table.find(".js-grand-total").find("input").val(formatMoney(grand));
  }

  function recalcAll($table) {
    $table.find("tbody tr[data-expense-indexes-id]").each(function () {
      recalcRowTotal($(this));
    });
    recalcColTotals($table);
    recalcGrandTotal($table);
  }

  // ===== OPEN MODAL =====

  $(document).on("click", ".js-open-expense-budget-modal", function () {
    var modalUrl = $(this).data("modal-url");
    var $content = $("#expense-budget-modal-content");

    $content.html(
      '<div class="text-center py-5">' +
        '<div class="spinner-border text-primary" role="status">' +
          '<span class="visually-hidden">読み込み中...</span>' +
        "</div>" +
      "</div>"
    );

    $("#expense-budget-modal").modal("show");

    $.ajax({
      url: modalUrl,
      method: "GET",
      success: function (html) {
        $content.html(html);
        recalcAll($("#expense-budget-table"));
      },
      error: function () {
        $content.html(
          '<div class="modal-body text-center text-danger py-4">データの読み込みに失敗しました。</div>'
        );
      },
    });
  });

  // ===== CLOSE MODAL =====

  $(document).on("click", "#expense-budget-modal-close, #expense-budget-cancel-btn", function () {
    $("#expense-budget-modal").modal("hide");
  });

  // ===== ENTER KEY → SAME COLUMN NEXT ROW; IF LAST ROW → FIRST ROW NEXT COLUMN =====

  $(document).on("keydown", ".js-expense-amount", function (e) {
    if (e.key !== "Enter") return;
    e.preventDefault();

    var $table   = $(this).closest("#expense-budget-table");
    var $td      = $(this).closest("td");
    var $row     = $(this).closest("tr");
    var colIndex = $row.children("td").index($td);
    var $nextRow = $row.next("tr[data-expense-indexes-id]");

    if ($nextRow.length) {
      // Same column, next row
      var $nextInput = $nextRow.children("td").eq(colIndex).find(".js-expense-amount");
      if ($nextInput.length) {
        $nextInput.focus().select();
        return;
      }
    }

    // Last row of column → first row of next column
    var $firstRow = $table.find("tbody tr[data-expense-indexes-id]").first();
    var $nextColInput = $firstRow.children("td").eq(colIndex + 1).find(".js-expense-amount");
    if ($nextColInput.length) {
      $nextColInput.focus().select();
      return;
    }

    // Last column & last row → move to save button
    $(".js-expense-budget-save").focus();
  });

  // ===== LIVE RECALC ON INPUT（入力はそのまま。検証は保存時のみ） =====
  $(document).on("input", ".js-expense-amount", function () {
    var $input = $(this);
    var $table = $input.closest("#expense-budget-table");
    var $row   = $input.closest("tr");
    recalcRowTotal($row);
    recalcColTotals($table);
    recalcGrandTotal($table);
  });

  // ===== INPUT VALIDATION =====

  var MAX_DIGITS = 99999999; // 8桁以内

  function getValidationMessages() {
    var $btn = $(".js-expense-budget-save");
    return {
      notInteger: $btn.data("msg-not-integer") || "整数で入力してください。",
      tooLong:    $btn.data("msg-too-long")    || "8桁以内で入力してください。"
    };
  }

  // Only validate when the user has entered a value; empty = valid
  function validateAmountInput($input, msgs) {
    var raw = $.trim($input.val());

    if (raw === "") return null;

    var stripped = raw.replace(/,/g, "");

    if (stripped === "-") return null;

    if (!/^-?\d+$/.test(stripped)) return msgs.notInteger;

    if (Math.abs(parseInt(stripped, 10)) > MAX_DIGITS) return msgs.tooLong;

    return null;
  }

  function validateAllAmounts($table) {
    var msgs       = getValidationMessages();
    var firstError = null;
    var firstInput = null;

    $table.find(".js-expense-amount").each(function () {
      var $input = $(this);
      var error  = validateAmountInput($input, msgs);

      $input.toggleClass("is-invalid", error !== null);

      if (error && !firstError) {
        firstError = error;
        firstInput = $input;
      }
    });

    if (firstError) {
      firstInput.focus();
      alert(firstError);
      return false;
    }
    return true;
  }

  // ===== SAVE =====

  $(document).on("click", ".js-expense-budget-save", function () {
    var $btn          = $(this);
    var budgetTableId = $btn.data("budget-table-id");
    var saveUrl       = $btn.data("save-url");
    var $table        = $("#expense-budget-table");

    if (!validateAllAmounts($table)) return;

    var formData = {};

    $table.find(".js-expense-amount").each(function () {
      var expId     = $(this).data("expense-indexes-id");
      var yearMonth = $(this).data("year-month");
      var raw       = $.trim($(this).val());

      var normalized = raw.replace(/,/g, "");

      // 送信は生の文字列（カンマ付き可）。サーバー側でも検証する
      var amountPayload = normalized === "" || normalized === "-" ? 0 : Number(normalized);

      if (!formData[expId]) formData[expId] = {};
      formData[expId][yearMonth] = amountPayload;
    });

    $btn.prop("disabled", true).text("保存中...");

    $.ajax({
      url: saveUrl,
      method: "POST",
      data: {
        budget_table_id:        budgetTableId,
        expense_budget_amounts: formData,
        authenticity_token:     $('meta[name="csrf-token"]').attr("content"),
      },
      success: function (response) {
        if (response.success) {
          updateOperatingProfitRow(budgetTableId, response.monthly_totals);

          $("#expense-budget-modal").modal("hide");

          toastOrAlert(response.message || "保存しました。");
        } else {
          alert("エラー: " + (response.message || "保存に失敗しました。"));
        }
      },
      error: function (xhr) {
        var msg = "保存に失敗しました。";
        try {
          var res = JSON.parse(xhr.responseText);
          if (res.message) msg = res.message;
        } catch (e) {}
        alert("エラー: " + msg);
      },
      complete: function () {
        $btn.prop("disabled", false).text("保存");
      },
    });
  });

  // ===== UPDATE 営業利益 ROW =====

  function updateOperatingProfitRow(budgetTableId, monthlyExpenseTotals) {
    var $section = $('[data-budget-table-id="' + budgetTableId + '"]');

    $section.find(".js-operating-profit-cell").each(function () {
      var month = $(this).data("month"); // "YYYY-MM"

      // Read sales and purchase from the editable table inputs for this month / col
      var colIndex = $(this).index() - 1; // offset for the <th> label column
      var $salesTd    = $section.find('tr[data-row="sales"] td').eq(colIndex);
      var $purchaseTd = $section.find('tr[data-row="purchase"] td').eq(colIndex);

      var sales    = parseMoney($salesTd.find("input").val());
      var purchase = parseMoney($purchaseTd.find("input").val());

      var expenseTotal = parseInt(monthlyExpenseTotals[month] || 0, 10);
      var operatingProfit = sales - purchase - expenseTotal;

      $(this).html(
        '<span class="' + (operatingProfit < 0 ? "text-danger" : "") + '">' +
          "¥" + operatingProfit.toLocaleString("ja-JP") +
        "</span>"
      );
    });
  }

  // ===== SIMPLE TOAST / FALLBACK =====

  function toastOrAlert(msg) {
    var $flash = $('<div class="alert alert-success alert-dismissible fade show position-fixed" ' +
                   'style="top:20px;right:20px;z-index:9999;min-width:200px;">' +
                   msg +
                   '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                   "</div>");
    $("body").append($flash);
    setTimeout(function () { $flash.alert("close"); }, 3000);
  }

});
